$(function () {
  var delay = (function () {
    var timer = 0;
    return function (callback, ms) {
      clearTimeout(timer);
      timer = setTimeout(callback, ms);
    };
  })();
  $('.ws-members input.ws-bikeguide-name').bind('keyup', function () {
    var searchValue = $(this).val();

    if (searchValue.length < 2) {
      return;
    }

    $('select.ws-region-select').val(0);
    if (!$('span.ws-search-label').length) {
      $(' <span class="ws-search-label" style="padding-left: 1em">Suche...</span>').insertAfter($('.ws-bikeguide-name-container'));
    }
    delay(function () {
      var obj = { name: searchValue, lang: $('html').attr('lang') };
      $.get('/ajax/members', obj, function (response) {
        $('.bikeguides-container').html(response);
        $('.ws-search-label').remove();
      });
    }, 700);
  });

  $('.ws-members select.ws-region-select').on('change', function () {
    if ($(this).val() != '0') {
      window.location = $(this).val();
    }
  });
});
